export const muted = "text-slate-500 dark:text-slate-400";
export const chip =
  "rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-[11px] font-medium text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300";
export const box =
  "flex flex-col items-start gap-1.5 rounded-[10px] border border-slate-200 bg-white p-3 text-sm text-slate-900 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100";
